import { render, staticRenderFns } from "./Document-pdf.vue?vue&type=template&id=34ffac08&scoped=true"
import script from "./Document-pdf.vue?vue&type=script&lang=js"
export * from "./Document-pdf.vue?vue&type=script&lang=js"
import style0 from "./Document-pdf.vue?vue&type=style&index=0&id=34ffac08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ffac08",
  null
  
)

export default component.exports